import React, {Component} from 'react';
import { LanguageConsumer } from '../lib/LanguageContext'
import './LegendInfo.css'


class LegendInfo extends Component {

    handleSelectChange = (e) => {
        let chosenClass = Number(e.target.value);
        this.props.handleChange(chosenClass);
    }

    closeModal = () => {
        this.props.closeModal();
    }

    render() {
        return(
          <LanguageConsumer>
            {({polyglot}) =>
                (<div className='LegendInfo'>
                    <div className="modalSelect">
                        <div className="select">
                            <span className="select-icon">
                                <Legend-color style={{backgroundColor: this.props.content.labelColor}}></Legend-color>
                            </span>
                            <select value={this.props.content.id} onChange={this.handleSelectChange}>
                                {
                                    this.props.content.allData.map(cl => <option key={cl.classId} value={cl.classId}>{polyglot.t(`grades.${cl.classId}`)}</option>)
                                }
                            </select>
                        </div>
                        <div className="closeModal" onClick={this.closeModal}>
                            <div id='x-icon'>
                                <span />
                                <span />
                                <span />
                                <span />
                            </div>
                        </div>
                    </div>
                    <div id='content-container' className={this.props.modalTransition}>
                            {
                                this.props.content.id !== 0 &&
                                <span>
                                    <div id='legendInfo-header'>
                                        {`${polyglot.t('recordsThatIncludeErr')} :`}
                                     </div>
                                    <ul>
                                        {
                                            this.props.content.errorsPerClass.map(err => <li key={err}> {polyglot.t(`errors.${err}`)}</li>)
                                        }
                                    </ul>
                                </span>
                            }
                            {
                                this.props.content.id === 0 &&
                                <span id='legendInfo-header'>
                                    {polyglot.t('recordsThatDontIncludeErr')}
                                </span>
                            }
                    </div>
                </div>)}
            </LanguageConsumer>
        )
    }
}

export default LegendInfo;



// WEBPACK FOOTER //
// ./src/components/LegendInfo.js